import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-atm-icon',
  templateUrl: './shopping-atm.component.html'
})
export class ShoppingATMComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
